
import css from './sass/adminpage.module.scss'
import themeCss from '../components/sass/theme.module.scss'

import { solicitationStatusDecoder } from './auctionsadminutil'

export default function SolicitationReview( { auctionDetail, history }) {

  const reviewStatus = auctionDetail?.ReviewStatus

  

  if (!auctionDetail) return <></>

  return (
    <div className={`${css['widget-container']} ${css['widget-solicitation']} ${css[`solicitation-card-${reviewStatus}`]}`}>
      <div className={css['flex-space-between-container']}>
        <h3>{auctionDetail.Title}</h3>
        <button id={`srPreviewTestSite-${auctionDetail.AuctionCode}`} className={`${themeCss['button']} ${themeCss['FilledBlue']}`}
        onClick ={(e) => {history.push({
            pathname: '/admin/auctiondetail',
            search: `?auctionId=${auctionDetail.AuctionCode}`,
          })}}>Preview Auction Details</button>
      </div>
      
      <div className={css['solicitation-input-container']}>
        <p>Solicitation Review Status:
          <span>{solicitationStatusDecoder[reviewStatus]}</span>
        </p>
      </div>
    </div>
  )
}